export default __webpack_public_path__ + "static/media/SYN.17db4c6d.svg";